import request from "@/service";

const blobOpts = {
  responseType: "blob",
  headers: {
    Accept: "application/json, text/plain, */*, application/octet-stream",
    "Content-Type": "application/json;charset=UTF-8",
  },
};

//班级列表 --- 要调整成post请求
export function getStudyClassList(data) {
  return request({
    url: `/study/classOffline/info/page`,
    method: "post",
    data,
  });
}

/* 班级新增 */
export function saveStudyClass(params) {
  return request({
    url: `/study/classOffline/info/save`,
    method: "post",
    data: params,
  });
}

/* 班级详情 */
export function getStudyClassInfo(uuid) {
  return request({
    url: `/study/classOffline/info/info/${uuid}`,
    method: "get",
  });
}

/* 班级修改 */
export function updateStudyClass(params) {
  return request({
    url: `/study/classOffline/info/update`,
    method: "put",
    data: params,
  });
}

/* 班级删除 */
export function deleteClass(params) {
  return request({
    url: `/study/classOffline/info/delete`,
    method: "delete",
    data: params,
  });
}
export function publishClass(params) {
  return request({
    url: `/study/classOffline/info/publish`,
    method: "put",
    data: params,
  });
}

//班级列表
export function treeChildVos(params) {
  return request({
    url: `/sys/sys/param/treeChildVos`,
    method: "get",
    params,
  });
}

/* 查询班级联络员 */
export function getLiaisonUserList(params) {
  return request({
    url: "/user/sys/user/listLiaisonUser",
    method: "get",
    params,
  });
}

/* 保存线下班级 */
export function saveOfflineClassNew(params) {
  return request({
    url: "/study/classOffline/info/saveNew",
    method: "post",
    data: params,
  });
}
// 轮训班查询人数
export function queryDownTrainEnrolls(params) {
  return request({
    url: "/study/classOffline/info/queryDownTrainEnrolls",
    method: "post",
    data: params,
  });
}
/**
 * 编辑线下班级
 * @param {*} params
 * @returns
 */
export function updateOfflineClassNew(params) {
  return request({
    url: "/study/classOffline/info/updateNew",
    method: "post",
    data: params,
  });
}

/* 查看线下班级详情 */
export function getClassOfflineInfo(params) {
  return request({
    url: "/study/classOffline/info/infoNew",
    method: "get",
    params,
  });
}

// 导入培训班级
export function importOfflineClass(params) {
  return request({
    url: "/study/classOffline/info/importOfflineClass",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut",
    },
    data: params,
  });
}

// 导入培训班级学员
export function importOfflineTrainEnroll(params) {
  return request({
    url: "/study/classOffline/enroll/importOfflineTrainEnroll",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut",
    },
    data: params,
  });
}

/**
 * 班级->同步至党校
 */
export function partyClassPush(params) {
  return request({
    url: "/study/classOffline/info/partyClassPush",
    method: "post",
    data: params,
  });
}

// 更新班级备注
export function updateRemarks(data) {
  return request({
    url: "/study/classOffline/info/updateRemarks",
    method: "post",
    data,
  });
}

// 导出选调名单
export function exportTransferClass(data) {
  return request({
    url: `/study/classOffline/info/exportTransferClass`,
    method: "post",
    data,
    ...blobOpts,
  });
}

// 导出选调报名表
export function exportTransferEnroll(data) {
  return request({
    url: `/study/classOffline/info/exportTransferEnroll`,
    method: "post",
    data,
    ...blobOpts,
  });
}

// 学员班内请假时长-wangchao
export function enrollLeaveDays(params) {
  return request({
    url: `/study/classOffline/enroll/enrollLeaveDays`,
    method: "get",
    params,
  });
}

/**
 * 按部门或权限查询用户-zhaogang
 * @param {*} params
 * @returns
 */
export function pageByDeptOrPermission(params) {
  return request({
    url: "/user/sys/user/pageByDeptOrPermission",
    method: "post",
    data: params,
  });
}

/**
 * 按部门或权限查询用户-zhaogang
 * @param {*} params
 * @returns
 */
export function saveBatchWorkers(params) {
  return request({
    url: "/study/class/liaison/user/saveBatch",
    method: "post",
    data: params,
  });
}

//班级列表 --- 要调整成post请求
export function updateOrder(params) {
  return request({
    url: "/study/classOffline/info/updateOrder",
    method: "post",
    data: params,
  });
}

/**
 * 自习室组列表
 * @param {*} params
 * @returns
 */
export function getClassRoomGroupPage(params) {
  return request({
    url: "/study/classRoomGroup/page",
    method: "get",
    params,
  });
}
/**
 * 自习室组save / update
 * @param {*} params
 * @returns
 */
export function classRoomGroupSave(params, isUpdate = false) {
  if (isUpdate) {
    return request({
      url: `/study/classRoomGroup/update`,
      method: "post",
      data: params,
    });
  }
  return request({
    url: `/study/classRoomGroup/save`,
    method: "post",
    data: params,
  });
}
/**
 * 自习室组详情
 * @param {*} params
 * @returns
 */
export function classRoomGroupInfo(params) {
  return request({
    url: "/study/classRoomGroup/info",
    method: "get",
    params,
  });
}
/**
 * 自习室组删除
 * @param {*} params
 * @returns
 */
export function classRoomGroupDelete(params) {
  return request({
    url: `/study/classRoomGroup/delete`,
    method: "post",
    data: params,
  });
}

// 导入自习室组
export function importRoomGroup(params) {
  return request({
    url: "/study/classRoomGroup/importRoomGroup",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut",
    },
    data: params,
  });
}

export function classEnrollGroupStatics(data) {
  return request({
    url: `/study/class/enroll/groupStatics`,
    method: "post",
    data,
  });
}

export function classEnrollGroupStatsPage(data) {
  return request({
    url: `/study/class/enroll/pageGroupStatics`,
    method: "post",
    data,
  });
}


export function exportGroupStatics(data) {
  return request({
    url: `/study/class/enroll/exportGroupStatics`,
    method: "post",
    data,
    ...blobOpts,
  });
}
